export const getDisplayName = ({ firstName = '', insertion = '', lastName = '' }) =>
	[firstName, insertion, lastName].join(' ');
